import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

import { JobCanOrderResponse } from '../models/job-can-order-response.model';

@Injectable({
  providedIn: 'root',
})
export class CanOrderForJobGQL extends Query<JobCanOrderResponse, { jobKey: string }> {
  override document = gql`
    query ($jobKey: UUID!) {
      canOrderForJob(jobKey: $jobKey) {
        canOrder
        reasonCode
      }
    }
  `;
}
